module.exports = __webpack_public_path__ + "8a52091c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legal-banner.jpg
// module id = 830
// module chunks = 0 1 2 3 4 5